export default {
  weeks: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  yearMonthFormat: 'YYYY年M月',
  weekStartsOn: 'Monday',
};
